/* LZ Black November „Znaš svoju veličinu“ — zajednička skripta za sekcije lz-bnv-hero i lz-bnv-grid.
   Kupac bira veličinu gornjeg dela u heroju (pamti se samo dok je kartica otvorena, sessionStorage; na novom ulasku
   nijedna veličina nije izabrana, Marko 20.10.2026),
   sekcija sa komadima pokazuje samo modele kojih ima u toj veličini, po kategoriji (tabovi).
   Pantalone i farmerke imaju svoj izbor širine unutar sekcije. Komad sa jednom opcijom ide u korpu jednim dodirom
   (tačna varijanta), fioka korpe se osvežava kao posle klasičnog dodavanja. Kod popusta (ako je zadat) se primenjuje
   preko /discount/<kod> pri prvom izboru veličine ili dodavanju u korpu.
   Učitava se iz obe sekcije; izvršava se jednom, ponovni poziv samo osvežava (theme editor). */
(() => {
  if (window.__lzbnv) { window.__lzbnv.render(); return; }
  const KEY = 'lz_bnv';
  const st = { top: '', bottom: '', tab: 0 };
  try { Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
  /* Kategoriju bira kupac sam: na ulasku i posle svakog izbora veličine nijedna pločica nije označena (Marko 17.10.2026) */
  st.tab = -1;
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const tpl = (str, map) => String(str || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
  const rank = (v) => { const i = ORDER.indexOf(String(v).toUpperCase()); if (i >= 0) return i; const n = parseFloat(String(v).replace(/[^0-9.]/g, '')); return isNaN(n) ? 999 : 100 + n; };
  const track = (ev, data) => {
    try {
      const p = Object.assign({ event: 'lz_bnv', action: ev }, data || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(p);
      document.dispatchEvent(new CustomEvent('lz:bnv', { detail: p }));
    } catch (e) {}
  };

  /* „Nisi još kupovao kod nas?“: visina + težina → veličina (tabele sa sajta, lz-size-reco.js), pa se klikne odgovarajući čip.
     X zatvara i pamti dok je kartica otvorena. */
  const calc = $('[data-lzbnv-calc]');
  if (calc && !calc.dataset.ready) {
    calc.dataset.ready = '1';
    const CK = 'lz_bnv_calc_x';
    let closed = false; try { closed = sessionStorage.getItem(CK) === '1'; } catch (e) {}
    const mini = calc.nextElementSibling && calc.nextElementSibling.matches('[data-calc-open]') ? calc.nextElementSibling : null;
    const setClosed = (v) => { calc.hidden = v; if (mini) mini.hidden = !v; try { if (v) sessionStorage.setItem(CK, '1'); else sessionStorage.removeItem(CK); } catch (e) {} };
    setClosed(closed);
    const out = $('[data-calc-out]', calc);
    $('[data-calc-close]', calc).addEventListener('click', () => setClosed(true));
    if (mini) mini.addEventListener('click', () => { setClosed(false); const h = $('[data-calc-h]', calc); if (h) h.focus(); });
    $('[data-calc-form]', calc).addEventListener('submit', (e) => {
      e.preventDefault();
      const h = $('[data-calc-h]', calc).value, w = $('[data-calc-w]', calc).value;
      const r = window.lzSizeReco ? window.lzSizeReco(h, w) : null;
      out.hidden = false;
      if (!r || !r.shirt) { out.textContent = calc.dataset.none || ''; return; }
      const chip = $('[data-chip][data-group="top"][data-value="' + r.shirt + '"]');
      let html = tpl(calc.dataset.result || '{size}', { size: '<b>' + r.shirt + '</b>' });
      if (r.shirtLoose && r.shirtLoose !== r.shirt) html += ' ' + tpl(calc.dataset.loose || '', { size: '<b>' + r.shirtLoose + '</b>' });
      out.innerHTML = html;
      if (chip && !chip.disabled) chip.click();
      track('calc', { h, w, size: r.shirt });
    });
  }
  /* Visina zaglavlja sajta (sticky) → tabovi se lepe ispod njega, skrol do komada staje ispod njega */
  const hdr = document.querySelector('.custom-header-sticky');
  let ticking = false;
  /* Zaglavlje je fixed i skriva se transformacijom (klasa is-hidden) uz prelaz, pa se visina čita iz offsetHeight,
     a ne iz getBoundingClientRect (koji usred prelaza daje pogrešnu vrednost). */
  const setTop = () => {
    ticking = false;
    let top = 0;
    if (hdr && !hdr.classList.contains('is-hidden') && hdr.offsetHeight > 0) top = Math.max(0, Math.round(hdr.offsetTop + hdr.offsetHeight));
    document.documentElement.style.setProperty('--lzbnv-top', top + 'px');
  };
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(setTop); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (hdr) { new MutationObserver(onScroll).observe(hdr, { attributes: true, attributeFilter: ['class'] }); hdr.addEventListener('transitionend', onScroll); }
  setTop();

  /* Fioka korpe zaključava body (overflow hidden) i strana skoči na vrh; posle zatvaranja vraćamo kupca tamo gde je bio. */
  let keepY = null;
  new MutationObserver(() => {
    if (keepY === null) return;
    if (!document.body.classList.contains('overflow-hidden')) { const y = keepY; keepY = null; window.scrollTo({ top: y, behavior: 'instant' }); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* Kod popusta: jednom po učitavanju, tiho */
  let codeDone = false;
  const applyCode = () => {
    const hero = $('[data-lzbnv-hero]');
    const code = hero && hero.dataset.code;
    if (!code || codeDone) return;
    codeDone = true;
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2F', { credentials: 'same-origin' }).catch(() => {});
  };

  const grid = () => $('[data-lzbnv-grid]');
  const pools = () => $$('[data-pool]', grid());
  const itemsOf = (p) => $$('[data-item]', p);
  const sizeFor = (p) => (p.dataset.group === 'bottom' ? st.bottom : st.top);
  const fits = (it, sz) => (it.dataset.sizes || '').indexOf('|' + sz + '|') !== -1;
  const listOf = (p) => {
    const sz = sizeFor(p);
    const min = parseInt(p.dataset.minShare, 10) || 0;
    return itemsOf(p).filter((it) => (sz ? fits(it, sz) : (parseInt(it.dataset.share, 10) || 0) >= min));
  };
  const parseVars = (s) => {
    const m = {};
    String(s || '').split('|').forEach((pair) => { const i = pair.indexOf(':'); if (i > 0) m[pair.slice(0, i)] = pair.slice(i + 1); });
    return m;
  };
  const withFilter = (url, param, sz) => {
    if (!url) return '#';
    if (!sz || !param) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'filter.v.availability=1&' + encodeURIComponent(param) + '=' + encodeURIComponent(sz);
  };

  /* Broj različitih modela po veličini (gornji deo: kroz sve kategorije; donji deo: unutar jedne kategorije) */
  const countSizes = (list) => {
    const c = {}, seen = {};
    list.forEach((p) => itemsOf(p).forEach((it) => {
      (it.dataset.sizes || '').split('|').filter(Boolean).forEach((sz) => {
        const k = sz + '|' + (it.dataset.handle || '');
        if (seen[k]) return;
        seen[k] = 1; c[sz] = (c[sz] || 0) + 1;
      });
    }));
    return c;
  };
  const chipHTML = (sz, n, word, on) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'lzbnv-chip' + (on ? ' is-on' : '');
    b.setAttribute('data-chip', '');
    b.dataset.group = 'bottom';
    b.dataset.value = sz;
    b.innerHTML = '<b></b><small><span></span><span class="lzbnv-chip__w"></span></small>';
    b.querySelector('b').textContent = sz;
    b.querySelector('small > span').textContent = n;
    b.querySelector('.lzbnv-chip__w').textContent = word ? ' ' + word : '';
    return b;
  };

  function renderHero() {
    const hero = $('[data-lzbnv-hero]');
    if (!hero) return;
    const word = hero.dataset.modelsWord || '';
    const top = pools().filter((p) => p.dataset.group !== 'bottom');
    const c = top.length ? countSizes(top) : null;
    $$('[data-chip][data-group="top"]', hero).forEach((chip) => {
      const v = chip.dataset.value;
      chip.classList.toggle('is-on', v === st.top);
      const small = $('[data-count]', chip);
      if (small && c) {
        const n = c[v] || 0;
        if (n) { small.innerHTML = '<span></span><span class="lzbnv-chip__w"></span>'; small.firstChild.textContent = n; small.lastChild.textContent = word ? ' ' + word : ''; }
        else small.textContent = hero.dataset.noneWord || '0';
        small.hidden = false;
        chip.disabled = n === 0 && v !== st.top;
      }
    });
    const hint = $('[data-pick-hint]', hero);
    if (hint && hint.dataset.tpl !== undefined) hint.innerHTML = st.top ? tpl(hint.dataset.tplOn || hint.dataset.tpl, { size: '<b>' + st.top + '</b>' }) : hint.dataset.tpl;
  }

  function renderGrid() {
    const g = grid();
    if (!g) return;
    const G = g.dataset;
    const all = pools();
    if (!all.length) return;
    const p = all.length > 1 ? all.find((x) => parseInt(x.dataset.pool, 10) === st.tab) : all[0];
    const word = G.modelsWord || '';
    all.forEach((x) => { x.hidden = x !== p; });
    const results = $('[data-results]', g);
    if (results) results.hidden = !p;
    if (!p) {
      /* Još nije izabrana kategorija: pločice sa brojem modela u izabranoj veličini, ništa označeno */
      st.tab = -1;
      $$('[data-tab]', g).forEach((t) => {
        const tp = all.find((x) => x.dataset.pool === t.dataset.tab);
        t.classList.remove('is-on');
        t.setAttribute('aria-pressed', 'false');
        const n = $('.lzbnv-tab__n', t);
        if (n && tp) {
          const k = listOf(tp).length, tsz = sizeFor(tp);
          n.textContent = tsz ? tpl(G.tileTpl || '{n}', { n: k, size: tsz }) : tpl(G.tilePlain || '{n}', { n: k });
          n.hidden = false;
        }
      });
      const title0 = $('[data-title]', g);
      if (title0) title0.innerHTML = G.titlePlain;
      const allLink0 = $('[data-all-link]', g);
      if (allLink0) {
        const base0 = allLink0.dataset.url || allLink0.getAttribute('href');
        allLink0.dataset.url = base0;
        allLink0.href = withFilter(base0, allLink0.dataset.param, st.top);
        allLink0.textContent = st.top ? tpl(allLink0.dataset.tplOn || allLink0.dataset.tpl, { size: st.top }) : allLink0.dataset.tpl;
      }
      return;
    }
    st.tab = parseInt(p.dataset.pool, 10) || 0;
    const sz = sizeFor(p);

    /* Pločice kategorija sa brojem modela u izabranoj veličini */
    $$('[data-tab]', g).forEach((t) => {
      const tp = all.find((x) => x.dataset.pool === t.dataset.tab);
      t.classList.toggle('is-on', tp === p);
      t.setAttribute('aria-pressed', tp === p ? 'true' : 'false');
      const n = $('.lzbnv-tab__n', t);
      if (n && tp) {
        const k = listOf(tp).length, tsz = sizeFor(tp);
        n.textContent = tsz ? tpl(G.tileTpl || '{n}', { n: k, size: tsz }) : tpl(G.tilePlain || '{n}', { n: k });
        n.hidden = false;
      }
    });

    /* Donji deo: izbor širine unutar sekcije */
    const pick = $('[data-sub-pick]', g);
    const bc = $('[data-chips="bottom"]', g);
    if (pick && bc) {
      if (p.dataset.group === 'bottom') {
        const c = countSizes([p]);
        const sizes = Object.keys(c).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
        bc.innerHTML = '';
        sizes.forEach((s) => bc.appendChild(chipHTML(s, c[s], word, s === st.bottom)));
        pick.hidden = !sizes.length;
      } else pick.hidden = true;
    }

    const items = itemsOf(p);
    let list = listOf(p);
    const limit = parseInt(G.limit, 10) || 8;
    /* Rasprodaje se: modeli kojih je malo u izabranoj veličini idu prvi (kad je uključeno) */
    const lowLimit = parseInt(G.lowQty, 10) || 0;
    if (lowLimit && sz) {
      const qOf = (it) => parseInt(parseVars(it.dataset.qty)[sz], 10) || 0;
      const isLowItem = (it) => { const q = qOf(it); return q > 0 && q <= lowLimit; };
      list = list.filter(isLowItem).concat(list.filter((it) => !isLowItem(it)));
      const wrap = $('[data-items]', p);
      if (wrap) list.forEach((it) => wrap.appendChild(it));
      items.forEach((it) => { if (list.indexOf(it) === -1 && wrap) wrap.appendChild(it); });
    }
    const expanded = p.dataset.expanded === '1';
    const show = expanded ? list : list.slice(0, limit);
    const quick = G.quickAdd !== '0';
    const lowQty = parseInt(G.lowQty, 10) || 0;
    let lowCount = 0;
    items.forEach((it, i) => {
      const on = show.indexOf(it) !== -1;
      it.hidden = !on;
      if (on) it.style.animationDelay = Math.min(show.indexOf(it), 8) * 40 + 'ms';
      /* „Još 3 kom.“ na slici kad u izabranoj veličini ima malo (prave zalihe) */
      const q = lowQty && sz ? parseInt(parseVars(it.dataset.qty)[sz], 10) : 0;
      const isLow = q > 0 && q <= lowQty;
      let badge = $('.lzbnv-low', it);
      if (isLow) {
        if (!badge) { const media = $('.lz-card__media, .lazare-product-card__media', it); if (media) { badge = document.createElement('span'); badge.className = 'lzbnv-low'; media.appendChild(badge); } }
        if (badge) { badge.textContent = tpl(G.lowBadge || 'Još {n}', { n: q }); badge.hidden = false; }
        if (list.indexOf(it) !== -1) lowCount++;
      } else if (badge) badge.hidden = true;
      const btn = $('[data-add]', it);
      const buy = $('.lz-card__buy, .lazare-product-card__actions', it);
      const vid = quick && sz ? parseVars(it.dataset.variants)[sz] : '';
      if (btn) {
        btn.hidden = !vid;
        if (vid && btn.dataset.id !== vid) { btn.dataset.id = vid; btn.dataset.size = sz; btn.disabled = false; btn.classList.remove('is-added', 'is-busy'); btn.textContent = tpl(G.addTpl, { size: sz }); }
      }
      if (buy) buy.hidden = !!vid;
    });

    const title = $('[data-title]', g);
    if (title) title.innerHTML = sz && p.dataset.group !== 'bottom' ? tpl(G.titleTpl, { size: '<b>' + sz + '</b>' }) : G.titlePlain;
    const cnt = $('[data-count]', g);
    if (cnt) cnt.textContent = sz ? tpl(G.countTpl, { n: list.length, size: sz, cat: p.dataset.label }) : tpl(G.countPlain, { n: list.length, cat: p.dataset.label });
    const low = $('[data-low]', g);
    if (low) {
      low.hidden = !(lowCount > 0 && sz);
      if (!low.hidden) {
        const m10 = lowCount % 10, m100 = lowCount % 100;
        const form = (m10 === 1 && m100 !== 11) ? (G.lowOne || G.lowTpl) : (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) ? (G.lowFew || G.lowTpl) : G.lowTpl;
        low.textContent = tpl(form || '{n}', { n: lowCount, size: sz });
      }
    }
    const empty = $('[data-empty]', p);
    if (empty) { empty.hidden = list.length > 0; empty.innerHTML = tpl(G.emptyTpl, { size: '<b>' + (sz || '') + '</b>', cat: '<b>' + p.dataset.label + '</b>' }); }
    const more = $('[data-more]', p);
    if (more) { more.hidden = expanded || list.length <= limit; more.textContent = tpl(G.moreTpl, { n: list.length - limit }); }
    const allBtn = $('[data-all]', p);
    if (allBtn) {
      allBtn.href = withFilter(p.dataset.url, p.dataset.param, sz);
      allBtn.textContent = sz ? tpl(G.allTpl, { cat: p.dataset.label, size: sz }) : tpl(G.allPlain, { cat: p.dataset.label });
    }
    const allLink = $('[data-all-link]', g);
    if (allLink) {
      const base = allLink.dataset.url || allLink.getAttribute('href');
      allLink.dataset.url = base;
      allLink.href = withFilter(base, allLink.dataset.param, st.top);
      allLink.textContent = st.top ? tpl(allLink.dataset.tplOn || allLink.dataset.tpl, { size: st.top }) : allLink.dataset.tpl;
    }
  }

  const render = () => { renderHero(); renderGrid(); };

  /* Dodavanje u korpu: tačna varijanta, fioka korpe se osvežava kao posle klasične forme */
  function syncHeader(cart) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !cart) return;
    let count = bubble.querySelector('.custom-header__cart-count');
    if (!count && cart.item_count > 0) { count = document.createElement('span'); count.className = 'custom-header__cart-count'; count.setAttribute('aria-hidden', 'true'); bubble.appendChild(count); }
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
  }
  function addToCart(btn) {
    const id = parseInt(btn.dataset.id, 10);
    if (!id || btn.disabled) return;
    const g = grid(); const G = g ? g.dataset : {};
    const it = btn.closest('[data-item]');
    btn.disabled = true; btn.classList.add('is-busy');
    applyCode();
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then((res) => {
        btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.textContent = G.addedText || 'Dodato';
        track('add_to_cart', { id: id, size: btn.dataset.size || '', handle: it ? it.dataset.handle : '' });
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          keepY = window.scrollY;
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
          drawer.renderContents(res);
        } else {
          fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()).then(syncHeader).catch(() => {});
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        setTimeout(() => { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = tpl(G.addTpl, { size: btn.dataset.size || '' }); }, 2600);
      })
      .catch(() => { btn.disabled = false; btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-chip]');
    if (chip) {
      if (chip.disabled) return;
      const group = chip.dataset.group === 'bottom' ? 'bottom' : 'top';
      const v = chip.dataset.value;
      st[group] = st[group] === v ? '' : v;
      if (group === 'top') { st.tab = -1; pools().forEach((p) => { delete p.dataset.expanded; }); }
      save();
      if (st[group]) applyCode();
      render();
      track('size', { group: group, size: st[group] });
      const g = grid();
      if (g && chip.closest('[data-lzbnv-hero]') && st[group]) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const tab = e.target.closest('[data-tab]');
    if (tab) {
      st.tab = parseInt(tab.dataset.tab, 10) || 0;
      save(); render();
      track('category', { category: tab.dataset.label || '' });
      const res = $('[data-results]', grid());
      if (res && tab.classList.contains('lzbnv-tile')) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const back = e.target.closest('[data-back-tiles]');
    if (back) { const tiles = $('[data-tabs]', grid()); if (tiles) tiles.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    const more = e.target.closest('[data-more]');
    if (more) { const p = more.closest('[data-pool]'); if (p) { p.dataset.expanded = '1'; render(); } return; }
    const add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    const copy = e.target.closest('[data-copy]');
    if (copy) {
      const code = copy.dataset.code || '';
      const done = () => { copy.classList.add('is-copied'); const l = $('[data-copy-label]', copy); if (l) { l.dataset.orig = l.dataset.orig || l.textContent; l.textContent = copy.dataset.copied || l.dataset.orig; setTimeout(() => { l.textContent = l.dataset.orig; copy.classList.remove('is-copied'); }, 2200); } applyCode(); track('copy_code', {}); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done); else done();
    }
  });

  window.__lzbnv = { render: render, state: st };
  render();
  document.addEventListener('shopify:section:load', render);
})();
